import { createFileRoute } from '@tanstack/react-router'
import { PlaceholderPage } from '@/components/common/PlaceholderPage'

export const Route = createFileRoute('/_auth/support')({
  component: () => <PlaceholderPage title="Support" />,
})
